import { get } from "lodash";
import htmlToFormattedText from "html-to-formatted-text";

export const modifyDataForPost = data => {
  return {
    // actionItemCOS: get(data, "actionItemCOS").filter(value => {
    //   return value.description && value.assignTo;
    // }),
    decisionStatus: get(data, "decisionStatus", null),
    description: htmlToFormattedText(get(data, "description", null)),
    id: get(data, "id", null),
    issueId: get(data, "issueId", null),
    issueStatus: get(data, "issueStatus") && +get(data, "issueStatus"),
    meetingId: get(data, "meetingId", null),
    taskCompletionDate: get(data, "taskCompletionDate", null) || null,
    recipientGroupId: +get(data, "assigneeGroupId"),
    files: get(data, "files", []).map(val => val.id),
    districtDept: get(data, "districtDept"),
    files: get(data, "files", []).map(val => val.id)
  };
};

export const modifyDataForIssueListPost = data => {
  return {
    decisionStatus: get(data, "decisionStatus", null),
    description: htmlToFormattedText(get(data, "description", null)),
    id: get(data, "id", null),
    issueId: get(data, "issueId", null),
    issueStatus: +get(data, "issueStatus", null),
    statusId: +get(data, "issueStatus", null),
    taskCompletionDate: get(data, "taskCompletionDate", null) || null,
    meetingId: get(data, "meetingId", null) || null,
    recipientGroupId: +get(data, "assigneeGroupId"),
    files: get(data, "files", []).map(val => val.id),
    districtDept: get(data, "districtDept"),
    task1: get(data, "task1", null),
    task1CompletionDate: get(data, "task1CompletionDate", null),
    task2: get(data, "task2", null),
    task2CompletionDate: get(data, "task2CompletionDate", null)
  };
};
